import Repository from './Repository'

export default {

    getStats() {
        return Repository.get('/user_stats');
    },
    
}